export default {"src":"/_next/static/media/roi-primary-school-icon.e108ed52.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};